import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../../searchresults/Address";
import { getDate } from "../../common/DisplayDate";
import getPersonName from "../../common/Name";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class HuntingPermits extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    const rows = [];
    let recCount = 0;
    if (props.node !== undefined) {
      const records = props.node;
      _.forEach(records, (record, index) => {
        const name = _.get(record, "huntingPermitHolder[0].name[0]");
        rows.push(
          <Table.Row
            key={`row_hun_perm_name_${index}`}
            className={index % 2 === 1 ? "table-row-odd-child" : ""}
          >
            <Table.Cell width={3}> Name: </Table.Cell>
            <Table.Cell width={7}>
              {name &&
                getPersonName(
                  _.get(name, "firstName[0]._", ""),
                  _.get(name, "middleName[0]._", ""),
                  _.get(name, "lastName[0]._", ""),
                  props
                )}
            </Table.Cell>
            <Table.Cell width={2}>Gender</Table.Cell>
            <Table.Cell width={3}>
              {_.get(record, "gender[0]._", "")}
            </Table.Cell>
          </Table.Row>
        );

        rows.push(
          <Table.Row
            key={`row_hun_perm_address_${index}`}
            className={index % 2 === 1 ? "table-row-odd-child" : ""}
          >
            <Table.Cell width={3}> Address: </Table.Cell>
            <Table.Cell width={8}>
              <Address
                addressNode={_.get(
                  record,
                  "huntingPermitHolder[0].address[0].address[0]"
                )}
                {...this.props}
              />
            </Table.Cell>
            <Table.Cell width={2}>Home State:</Table.Cell>
            <Table.Cell width={3}>
              {_.get(record, "huntingPermitHolder[0].homeState[0]._", "")}
            </Table.Cell>
          </Table.Row>
        );

        const licenseDate = _.get(record, "issueDate[0]");
        rows.push(
          <Table.Row
            key={`row_hun_perm_dob_${index}`}
            className={index % 2 === 1 ? "table-row-odd-child" : ""}
          >
            <Table.Cell width={3}> License Date:</Table.Cell>
            <Table.Cell width={8}>
              {licenseDate && getDate(licenseDate)}
            </Table.Cell>
            <Table.Cell width={2}>License State:</Table.Cell>
            <Table.Cell width={3}>
              {_.get(record, "huntingPermitHolder[0].homeState[0]._", "")}
            </Table.Cell>
          </Table.Row>
        );
      });
      recCount = records.length;
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Hunting Permits"}
        rows={this.state.rows}
      />
    );
  }
}

export default HuntingPermits;



// WEBPACK FOOTER //
// ./src/components/reports/Silver/HuntingPermits.js